import React from 'react';
import { LockIcon, RadioIcon } from 'lucide-react';
type LiveAccessButtonProps = {
  availability: string;
};
export function LiveAccessButton({
  availability
}: LiveAccessButtonProps) {
  return <button type="button" disabled aria-disabled="true" aria-describedby="live-availability" className="flex h-full w-full cursor-not-allowed flex-col justify-between gap-6 rounded-2xl border-2 border-dashed border-black/15 bg-white/50 p-5 text-left text-ink sm:p-6" data-id="element-9" data-mp="1vfllu7qvpeo8">
      <div className="flex w-full items-start justify-between" data-id="element-10" data-mp="2j5pq8hbw5iga">
        <span className="flex h-11 w-11 items-center justify-center rounded-full bg-black/[0.06] text-muted" data-id="element-11" data-mp="2e6w9mg1b5bbw">
          <RadioIcon className="h-5 w-5" aria-hidden="true" data-id="element-12" data-mp="2981sdiiznutw" />
        </span>
        <LockIcon className="h-5 w-5 text-muted" aria-hidden="true" data-id="element-13" data-mp="29a5v3x55insl" />
      </div>
      <div data-id="element-14" data-mp="12t0uh7ael2ko">
        <span className="block whitespace-nowrap text-xl font-semibold tracking-tight text-ink/45 sm:text-2xl" data-id="element-15" data-mp="12pmsi05nivdr">
          Accéder au live
        </span>
        <span id="live-availability" className="mt-2 inline-flex items-center gap-2 rounded-full bg-cnt-yellow/20 px-3 py-1 text-sm font-medium text-[#8a5a00]" data-id="element-16" data-mp="3isfg4pxbvhcu">
          <span className="h-1.5 w-1.5 rounded-full bg-cnt-yellow" aria-hidden="true" data-id="element-17" data-mp="38tzomlue262t" />
          {availability}
        </span>
      </div>
    </button>;
}